import { render } from "./RegisterExtension.vue?vue&type=template&id=2be97128&scoped=true"
import script from "./RegisterExtension.vue?vue&type=script&lang=js"
export * from "./RegisterExtension.vue?vue&type=script&lang=js"

import "./RegisterExtension.vue?vue&type=style&index=0&id=2be97128&scoped=true&lang=less"

import exportComponent from "/build/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2be97128"]])

export default __exports__